






























































































































































import Vue from 'vue'
import _ from 'lodash'
import ProjectWindow from '@/components/project/ProjectWindow.vue'
import moment from 'moment'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxSelection,
  DxColumnChooser,
  DxSorting,
  DxFilterRow, DxGroupPanel, DxGrouping, DxStateStoring
} from 'devextreme-vue/data-grid'
import { DxCheckBox } from 'devextreme-vue/check-box';
import { ProjectSearchRequest } from '@/types/payload'
import { FETCH_PROJECT_DATE, FETCH_SEARCH_PROJECT_LIST } from '@/store/action-types'
import { ProjectSearch } from '@/model/project/ProjectSearch'
import CreateProjectAssistant from '@/components/project/CreateProjectAssistant.vue'
import { AutomaticOneResponse } from '@/types/service-response'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { loadMessages, locale } from 'devextreme/localization'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'
import { KeyActionEnum } from '@/types/enums'

class SelectAll extends KeyAction {}

interface ComponentData {
  tableHeight: string
  menu1: boolean
  menu2: boolean
  projectDateFrom: string
  projectDateFromFormatted: string
  projectDateTo: string
  projectDateToFormatted: string
  dateRules: any[]
  field1: string
  field2: string
  field3: string
  field4: string
  field5: string
  field6: string
  field7: string
  field8: string
  field9: string
  field10: string
  field11: string
  field12: string
  field13: string
  field14: string
  check: boolean
  projectList: ProjectSearch[]
  isLoading: boolean
  showDialog: boolean
  projectIdList: number[]
  isDetailButtonDisabled: boolean
  showCreateAssistant: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ProjectPage',

  components: {
    ProjectWindow,
    CreateProjectAssistant,
    DxDataGrid,
    DxColumn,
    DxCheckBox,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring
  },

  props: {
    projectCode: String,
    projectBez: String
  },

  data (): ComponentData {
    return {
      tableHeight: 'height: 500px',
      menu1: false,
      menu2: false,
      projectDateFrom: '',
      projectDateFromFormatted: '',
      projectDateTo: '',
      projectDateToFormatted: '',
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          return value.length !== 10 ? this.$t('errors.wrongDate').toString() : true
        }
      ],
      field1: '',
      field2: '',
      field3: '',
      field4: '',
      field5: '',
      field6: '',
      field7: '',
      field8: '',
      field9: '',
      field10: '',
      field11: '',
      field12: '',
      field13: '',
      field14: '',
      check: true,
      projectList: [],
      isLoading: false,
      showDialog: false,
      projectIdList: [],
      isDetailButtonDisabled: true,
      showCreateAssistant: false,

      keyActions: []
    }
  },

  watch: {
    $route (newVal: any): void {
      if(newVal.query.create) {
        this.showCreateAssistant = true
      }

      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 0)
    },

    projectCode (newVal: string): void {
      if(newVal) {
        this.field8 = newVal
      }
    },

    projectBez (newVal: string): void {
      if(newVal) {
        this.field9 = newVal.replace('-','/')
      }
    },

    projectDateFromFormatted (newVal: string): void {
      if(newVal) {
        this.projectDateFrom = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.projectDateFrom = ''
      }
    },

    projectDateToFormatted (newVal: string): void {
      if(newVal) {
        this.projectDateTo = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
      } else {
        this.projectDateTo = ''
      }
    }
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    currentUserId (): number | undefined {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    }
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: SelectAll | null): boolean {
      if(action instanceof SelectAll) {
        return !this.showDialog
      } else {
        return false
      }
    },

    selectAll (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }
      //@ts-ignore
      this.$refs.dataGrid.instance.selectAll()
    },

    formatDate (date: string): string {
      return moment(date).format('DD.MM.YYYY')
    },

    onProjectDateFromChange (date: string): void {
      this.projectDateFromFormatted = moment(date).format('DD.MM.YYYY')
    },

    onProjectDateToChange (date: string): void {
      this.projectDateToFormatted = moment(date).format('DD.MM.YYYY')
    },

    onFocusProjectFrom (): void {
      setTimeout(() => {
        if(!this.menu1) {
          this.menu1 = true
        }
      }, 100)
    },

    onBlurProjectFrom (): void {
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    onFocusProjectTo (): void {
      setTimeout(() => {
        if(!this.menu2) {
          this.menu2 = true
        }
      }, 100)
    },

    onBlurProjectTo (): void {
      setTimeout(() => {
        if(this.menu2) {
          this.menu2 = false
        }
      }, 100)
    },

    onCreatedProject(projectId: number) : void {
      this.$router.push({ path: '/project'})
      this.showCreateAssistant = false
      this.projectIdList = [projectId]
      this.showDialog = true
    },

    onCloseCreateProjectClick (): void {
      this.$router.push({ path: '/project'})
      this.showCreateAssistant = false
    },

    onSearchButtonClick (): void {
      let data: any = this.getRouteData()

      data.ProjektN = this.field1
      data.Sachbearbeiter = this.field2
      data.UnsereReferenz = this.field3
      data.IhreReferenz = this.field4
      data.KommisionsNr = this.field5
      data.Adresse = this.field6
      data.KommisionsBez = this.field7
      data.ProzessArtCode = this.field8
      data.ProzessArtBez = this.field9
      data.ProfitCenterCode = this.field10
      data.ProfitCenterBez = this.field11
      data.Belegnummer = this.field12
      data.ProdNummerBez = this.field13
      data.KLProduktNr = this.field14
      data.AuchErledigteProjekte = this.check
      data.VonProjektdatum = this.projectDateFrom
      data.BisProjektdatum = this.projectDateTo

      this.$router.push({name: 'Project', query: { data: JSON.stringify(data) }})

      this.getProjectList()
    },

    onSelectionChanged (data: any) {
      this.isDetailButtonDisabled = data.selectedRowKeys.length <= 0

      let ruteData: any = this.getRouteData()
      ruteData.selectedRowKeys = data.selectedRowKeys
      this.$router.push({name: 'Project', query: { data: JSON.stringify(ruteData) }})
    },

    rowDblClick(event: any): void {
      this.projectIdList.push(event.data.ID)
      this.showDialog = true

      let ruteData: any = this.getRouteData()
      ruteData.selectedRowKeys = [event.data.ID]
      ruteData.showDialog = this.showDialog
      this.$router.push({name: 'Project', query: { data: JSON.stringify(ruteData) }})
    },

    onDetailClick (): void {
      //@ts-ignore
      const selectedProjectIdList: number[] = this.$refs.dataGrid.instance.getSelectedRowKeys()

      if(selectedProjectIdList.length > 0) {
        this.projectIdList = selectedProjectIdList
        this.showDialog = true

        let ruteData: any = this.getRouteData()
        ruteData.showDialog = this.showDialog
        this.$router.push({name: 'Project', query: { data: JSON.stringify(ruteData) }})
      }
    },

    onCreateProject (projectId: number): void {
      this.projectIdList = [projectId]
    },

    editedProject (): void {
      let data: any = this.getRouteData()
      this.getProjectList(data.selectedRowKeys)
    },

    onDeleteProject (selectedProjectId: number, selectedProjectIndex: number): void {
      const foundProject: ProjectSearch | undefined =  this.projectList.find((item: ProjectSearch) => item.ID === selectedProjectId)
      if(foundProject) {
        const index: number = this.projectList.indexOf(foundProject)
        this.projectList.splice(index, 1)
        this.projectIdList.splice(selectedProjectIndex, 1)
      }

      if(this.projectIdList.length === 0) {
        this.showDialog = false
      }
    },

    onProjectWindowClose (): void {
      this.showDialog = false
      this.projectIdList = []
      let data: any = this.getRouteData()
      if(data.showDialog !== undefined) {
        delete data.showDialog
      }
      if(data.projectTab != undefined) {
        delete data.projectTab
      }
      if(data.projectIdIndex !== undefined) {
        delete data.projectIdIndex
      }
      if(data.detailIndex !== undefined) {
        delete data.detailIndex
      }
      if(data.detailTab !== undefined) {
        delete data.detailTab
      }
      this.$router.push({name: 'Project', query: { data: JSON.stringify(data) }})
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 105px - ${height}px)`
        } else {
          this.tableHeight = 'height: 500px'
        }
      } else {
        this.tableHeight = 'height: 500px'
      }
    },

    async getProjectList (keyList?: number[]): Promise<void> {
      this.projectList = []
      this.isLoading = true
      const payload : ProjectSearchRequest = {
        ProjektN: this.field1,
        Sachbearbeiter: this.field2,
        UnsereReferenz: this.field3,
        IhreReferenz: this.field4,
        KommisionsNr: this.field5,
        KommisionsBez: this.field7,
        Adresse: this.field6,
        ProzessArtCode: this.field8,
        ProzessArtBez: this.field9,
        ProfitCenterCode: this.field10,
        ProfitCenterBez: this.field11,
        Belegnummer: this.field12,
        AuchErledigteProjekte: this.check,
        VonProjektdatum: this.projectDateFrom ? moment(this.projectDateFrom).format('YYYY/MM/DD') : '',
        BisProjektdatum: this.projectDateTo ? moment(this.projectDateTo).format('YYYY/MM/DD') : '',
        ProdNummerBez: this.field13,
        KLProduktNr: this.field14,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId!,
        MaxRecords: 500
      }

      try {
        this.projectList = await this.$store.dispatch(FETCH_SEARCH_PROJECT_LIST, payload)

        let data: any = this.getRouteData()
        if(this.$route.path === '/project' && data.selectedRowKeys) {
          let selectedRowKeyList: number[] = []
          this.projectList.forEach((item: ProjectSearch) => {
            if(keyList) {
              if(keyList.includes(item.ID)) {
                selectedRowKeyList.push(item.ID)
              }
            } else if(data.selectedRowKeys.includes(item.ID)) {
              selectedRowKeyList.push(item.ID)
            }
          })

          setTimeout(() => {
            //@ts-ignore
            this.$refs.dataGrid.instance.selectRows(selectedRowKeyList)
            this.showDialog = data.showDialog !== undefined ? data.showDialog : false
          }, 100)
        }
      } catch {

      } finally {
        this.isLoading = false
      }
    },

    async fetchProjectDate (): Promise<void> {
      try {
        const response: AutomaticOneResponse = await this.$store.dispatch(FETCH_PROJECT_DATE)
        this.projectDateFrom = !response.IsError && response.Data && response.Data.FromProjectDate ? moment(response.Data.FromProjectDate).format('YYYY-MM-DD') : moment().startOf('month').format('YYYY-MM-DD')
        this.projectDateTo =  !response.IsError && response.Data && response.Data.ToProjectDate ? moment(response.Data.ToProjectDate).format('YYYY-MM-DD') : moment().endOf('year').format('YYYY-MM-DD')
        this.projectDateFromFormatted = !response.IsError && response.Data && response.Data.FromProjectDate ? moment(response.Data.FromProjectDate).format('DD.MM.YYYY') : moment().startOf('month').format('DD.MM.YYYY')
        this.projectDateToFormatted = !response.IsError && response.Data && response.Data.ToProjectDate ? moment(response.Data.ToProjectDate).format('DD.MM.YYYY') : moment().endOf('year').format('DD.MM.YYYY')
      } catch {
        this.projectDateFrom = moment().startOf('month').format('YYYY-MM-DD')
        this.projectDateTo = moment().endOf('year').format('YYYY-MM-DD')
        this.projectDateFromFormatted = moment().startOf('month').format('DD.MM.YYYY')
        this.projectDateToFormatted = moment().endOf('year').format('DD.MM.YYYY')
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if(this.$route.path === '/project') {
        this.field1 = data && data.ProjektN ? data.ProjektN : ''
        this.field2 = data && data.Sachbearbeiter ? data.Sachbearbeiter : ''
        this.field3 = data && data.UnsereReferenz ? data.UnsereReferenz : ''
        this.field4 = data && data.IhreReferenz ? data.IhreReferenz : ''
        this.field5 = data && data.KommisionsNr ? data.KommisionsNr : ''
        this.field6 = data && data.Adresse ? data.Adresse : ''
        this.field7 = data && data.KommisionsBez ? data.KommisionsBez : ''
        this.field8 = data && data.ProzessArtCode ? data.ProzessArtCode : ''
        this.field9 = data && data.ProzessArtBez ? data.ProzessArtBez : ''
        this.field10 = data && data.ProfitCenterCode ? data.ProfitCenterCode : ''
        this.field11 = data && data.ProfitCenterBez ? data.ProfitCenterBez : ''
        this.field12 = data && data.Belegnummer ? data.Belegnummer : ''
        this.field13 = data && data.ProdNummerBez ? data.ProdNummerBez : ''
        this.field14 = data && data.KLProduktNr ? data.KLProduktNr : ''
        this.check = data && data.AuchErledigteProjekte !== undefined ? data.AuchErledigteProjekte : true
        this.projectDateFrom = data && data.VonProjektdatum && moment(data.VonProjektdatum).isValid() ? data.VonProjektdatum : this.projectDateFrom
        this.projectDateTo = data && data.BisProjektdatum && moment(data.BisProjektdatum).isValid() ? data.BisProjektdatum : this.projectDateTo
        this.projectDateFromFormatted = moment(this.projectDateFrom).format('DD.MM.YYYY')
        this.projectDateToFormatted = moment(this.projectDateTo).format('DD.MM.YYYY')

        this.projectIdList = data.selectedRowKeys ? data.selectedRowKeys : []

        if(!_.isEmpty(data)) {
          this.getProjectList()
        }
      }
    }
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  beforeMount () {
    this.keyActions = [
      new SelectAll(KeyActionEnum.selectAll, this.selectAll, this.resolver,  null)
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)

    this.setDataFromRoute()
    if(!this.projectDateFrom && !this.projectDateTo) {
      this.fetchProjectDate()
    }
    if(this.projectCode) {
      this.field8 = this.projectCode
    }
    if(this.projectBez) {
      this.field9 = this.projectBez.replace('-','/')
    }
    if(this.$route.query.create) {
      this.showCreateAssistant = true
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
